export const getMapsLocationUrl = (
    zoom: number,
    latitude?: number | undefined,
    longitude?: number | undefined,
    postalCode?: string | undefined,
    city?: string | undefined,
    addressRow1?: string | undefined,
): string | undefined => {
    const encodedAddress =
        addressRow1 && postalCode && city
            ? encodeURIComponent(`${addressRow1}, ${postalCode}, ${city}`)
            : undefined;
    return latitude && longitude && 1 <= zoom && zoom <= 20
        ? `https://maps.google.com/?q=${latitude},${longitude}&ll=${latitude},${longitude}&z=${zoom}`
        : encodedAddress && 1 <= zoom && zoom <= 20
          ? `https://maps.google.com/?q=${encodedAddress}&z=${zoom}`
          : undefined;
};
